import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output
} from '@angular/core';
import { SignupStepsState } from '../sign-up-steps-state';

@Component({
	selector: 'lti-confirmation',
	templateUrl: './lti-confirmation.component.html',
	styleUrls: ['./lti-confirmation.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LTIConfirmationComponent {
	@Output()
	public onBack = new EventEmitter<SignupStepsState>(); // eslint-disable-line @angular-eslint/no-output-on-prefix
	@Output()
	public onProceed = new EventEmitter<SignupStepsState>(); // eslint-disable-line @angular-eslint/no-output-on-prefix

	constructor () {}

	public back () {
		this.onBack.emit();
	}

	public proceed () {
		this.onProceed.emit();
	}
}
